import MetaTag from "components/Common/Meta-tag"
import React from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Container } from "reactstrap"
import Form from "./Form"

function Create() {
  return (
    <div>
      <MetaTag title={"Create Vehicle"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard / Vehicle" breadcrumbItem="Create" />
        <Container fluid>
          <div className="container-fluid">
            <Form updateData={false} />
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Create
